import { useState } from 'react';
import { JournalVoucherList } from '../components/JournalVoucherList';
import { ContraEntries } from '../components/ContraEntries';
import { RecurringEntries } from '../components/RecurringEntries';
import { VoucherBooksList } from '../components/VoucherBooksList';

const TABS = [
  { id: 'journals', label: 'Journal Vouchers' },
  { id: 'contra', label: 'Contra Entries' },
  { id: 'recurring', label: 'Recurring Entries' },
  { id: 'voucher-books', label: 'Voucher Books' },
];

export function TransactionsPage() {
  const [tab, setTab] = useState('journals');

  return (
    <div className="p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Transactions</h1>
        <p className="text-sm text-muted-foreground mt-1">Journal vouchers, contra entries and recurring templates</p>
      </div>
      <div className="flex gap-2 border-b">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${tab === t.id ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'journals' && <JournalVoucherList />}
      {tab === 'contra' && <ContraEntries />}
      {tab === 'recurring' && <RecurringEntries />}
      {tab === 'voucher-books' && <VoucherBooksList />}
    </div>
  );
}
